import React from "react";
import UI from "@components/Home/Favourites/Tile/UI";
import { Artist as ArtistType } from "@libs/wire";

const Artist = ({ artist }: { artist: ArtistType }) => {
  return (
    <UI
      title={artist.name}
      images={artist.image}
      href={{
        pathname: "/(app)/(tabs)/explore/artist/[artistId]",
        params: {
          artistId: artist.id,
          collectionType: "artist",
        },
      }}
    />
  );
};

export default Artist;
